<template>
  <div class="action-control">
<!--    <div v-if="isBasket && !isGift" class="action-control__control-holder">-->
<!--      <button-->
<!--        type="button"-->
<!--        class="action-control__control _wish"-->
<!--        :class="{ '_active': isWishItem && isAuthorized }"-->
<!--        :disabled="isLoading"-->
<!--        @click.prevent="toggleToFavorites"-->
<!--      >-->
<!--        <bookmark16 class="action-control__icon" :width="16" :height="16" />-->
<!--        {{ wishText }}-->
<!--      </button>-->
<!--    </div>-->
    <div class="action-control__control-holder">
      <button
        class="action-control__control"
        type="button"
        :disabled="isDisabledDeleted"
        @click.prevent="handlerRemoveItem"
      >
        <trash16 class="action-control__icon" :width="16" :height="16" />
        Удалить
      </button>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';

import Trash16 from '@/assets/sprite/svg/16/Trash_16.svg';
import Bookmark16 from '@/assets/sprite/svg/16/Bookmark_16.svg';

import useControlsItem from '@/compositions/useControlsItem';

export default defineComponent({
  name: 'ActionControl',
  components: { Trash16, Bookmark16 },
  props: {
    productId: { type: [Number, String], required: true },
    categoryId: { type: [Number, String], required: true },
    isGift: { type: Boolean, default: false },
    isBasket: { type: Boolean, default: false },
    isDisabledDeleted: { type: Boolean, default: false },
    amount: { type: Object, default: () => ({ discounted: 0, total: 0 }) },
  },
  setup(props) {
    const controlsItem = useControlsItem(props);
    return {
      ...controlsItem,
    };
  },
});
</script>

<style lang="less">
.action-control {
  display: flex;
  justify-content: flex-end;

  &__control-holder {
    margin-left: @size-x6;

    &:first-child {
      margin-left: 0;
    }
  }

  &__control {
    .button-reset();
    .small();

    display: flex;
    align-items: center;
    justify-content: center;
    color: @gray-dark;
    transition: color @A;

    &:hover,
    &._tap {
      color: @link-hover;
    }
  }

  &__icon {
    fill: @gray-dark;
    margin-right: @size-x2;
  }

  &__control._active &__icon {
    fill: @pink;
  }
}
</style>
